<template>
  <div v-show="show">
    <div class="child" :style="{ height: lineheight + 'px' }">
      <div class="partBarHolder">
        <v-touch
          @panmove="onPanMove"
          @panstart="onPanStart"
          @panend="onPanEnd"
          v-bind:pan-options="{ direction: 'horizontal', threshold: 2 }"
        >
          <div
            class="partComponent partBar stagePartPar"
            @click="(selectionAllowed && selectStage(stage)) || null"
            @dblclick="toggleStageChildren(stage)"
            :class="[alertIndicator, { moreLeft: left < 0 }]"
            :style="{
              top: lineheight - 12 + 'px',
              left: leftPos,
              width: width,
              backgroundColor: stage.colour,
              cursor: draggingAllowed ? 'move' : 'pointer',
            }"
            :title="startdate"
          >
            <span ref="bar" class="partBarTitle">
              {{ stage.title }}
            </span>
          </div>
        </v-touch>
      </div>
    </div>

    <div v-show="stage.showChildren">
      <div v-for="(child, index) in filteredChildren" :key="child._id">
        <Stage
          :lineheight="lineheight"
          :treeChild="child"
          :showAlerts="showAlerts"
          v-if="child.type == 'Stage'"
          :lockedDragNDrop="stage.lockedDragNDrop || lockedDragNDrop"
          :level="level + 1"
          :children="child.children"
          :stage="fetchStage(child._id)"
          :filterDate="filterDate"
          :filterDateEnd="filterDateEnd"
          :filterDateZoom="filterDateZoom"
        />
        <Part
          :lineheight="lineheight"
          :treeChild="child"
          :showAlerts="showAlerts"
          v-if="child.type == 'Part'"
          :lockedDragNDrop="stage.lockedDragNDrop || lockedDragNDrop"
          :level="level + 1"
          :stage="stage"
          :part="fetchPart(child._id)"
          :filterDate="filterDate"
          :filterDateZoom="filterDateZoom"
        />
      </div>
    </div>
  </div>
</template>
<script>
import Part from './Part';
import { mapGetters, mapActions } from 'vuex';
import moment from 'moment';
import draggable from 'vuedraggable';
import * as stageHelpers from '@/common/stageHelpers';
import * as treeHelpers from '@/common/treeHelpers';

export default {
  name: 'Stage',
  data: () => {
    return {
      panning: false,
      panStartdate: moment(),
      panStart: moment(),
    };
  },
  props: [
    'children',
    'filterDate',
    'filterDateEnd',
    'filterDateZoom',
    'level',
    'lineheight',
    'lockedDragNDrop',
    'showAlerts',
    'showHiddenStages',
    'stage',
    'treeChild',
  ],
  methods: {
    ...mapActions(['moveStageChildren', 'selectStage', 'toggleStageChildren']),
    onPanStart: function (e) {
      if (!this.draggingAllowed) {
        return;
      }
      this.panStart = moment(this.startdate);
      this.panStartdate = this.startdate;
      this.panning = true;
    },
    onPanEnd: function (e) {
      if (!this.draggingAllowed) {
        return;
      }

      this.panning = false;
      this.moveStageChildren({
        updateStage: this.stage,
        parent: treeHelpers.findChildren(this.currentProject.children, this.stage._id),
        relativeStartdays: moment(this.panStartdate).diff(this.panStart, 'days'),
      });
      // this.saveStagProperties({updateStage: this.part, newPartProperties: {startdate: this.part.startdate, expectedDonedate: this.part.expectedDonedate, time: this.part.time, calendarTime: this.part.calendarTime}});
    },
    onPanMove: function (e) {
      if (!this.draggingAllowed) {
        return;
      }
      // this.setStageProperties({updatePart: this.part, newPartProperties: {startdate: moment(this.panStart).add(e.deltaX / (this.filterDateZoom), 'days').format('YYYY-MM-DD')}});
      this.panStartdate = moment(this.panStart)
        .add(e.deltaX / (this.filterDateZoom * this.viewSettings.projectPlan.zoomFactor), 'days')
        .format('YYYY-MM-DD');
    },
    calculateStartdate: stageHelpers.calculateStartdate,
    calculateTime: stageHelpers.calculateTime,
  },
  computed: {
    ...mapGetters([
      'fetchStage',
      'fetchPart',
      'viewSettings',
      'projectDraggingAllowed',
      'currentProject',
      'hasSimplePermissions',
    ]),
    show: function () {
      return this.stage.show || this.showHiddenStages;
    },
    alertIndicator: function () {
      return this.showAlerts ? this.treeChild.alert.css : '';
    },
    draggingAllowed: function () {
      return (
        this.hasSimplePermissions('movePartBar') &&
        !this.lockedDragNDrop &&
        !this.stage.lockedDragNDrop &&
        this.projectDraggingAllowed
      );
    },
    selectionAllowed() {
      return this.hasSimplePermissions('selectStage');
    },
    startdate: function () {
      if (this.panning) {
        return this.panStartdate;
      }
      return this.calculateStartdate(this.$store, this.filterDate, this.children);
    },
    calendarTime: function () {
      return this.calculateTime(this.$store, this.filterDate, this.children);
    },
    paddingLeft: function () {
      return this.level * 10 + 'px';
    },
    leftPos: function () {
      var leftPos = this.left;
      if (leftPos < 0) {
        leftPos = 0;
      }

      return leftPos + 'px';
    },
    width: function () {
      var left = this.left;
      var width =
        this.calendarTime * this.filterDateZoom * this.viewSettings.projectPlan.zoomFactor + Math.min(0, left);
      if (width < 10) {
        width = 10;
      }
      return width + 'px';
    },
    left: function () {
      var start = moment(this.startdate);
      var first = moment(this.filterDate);
      var left =
        (this.filterDateZoom * this.viewSettings.projectPlan.zoomFactor * (start - first)) / (1000 * 60 * 60 * 24);

      return left;
    },
    filteredChildren: {
      get: function () {
        // console.log(JSON.stringify(this.stage));
        // console.log(JSON.stringify(this.children));
        return this.children;
      },
      set: function (value) {},
    },
  },
  components: {
    Part: Part,
    draggable,
  },
};
</script>

<style scoped>
.child {
  border-bottom: 1px solid #aaaaaa;
  z-index: 100;
}

.partComponent {
  white-space: nowrap;
  display: inline-block;
  position: relative;
  margin: 0px;
  vertical-align: top;
}

.partBarHolder {
  display: inline-block;
  position: absolute;
  overflow: visible;
}
.partBar {
  box-sizing: border-box;
  background: #091d2e;
  border: none;
  padding-left: 3px;
  font-size: 0.8125rem;
  white-space: nowrap;
  margin-top: 1px;
}

.partBar .partBarTitle {
  margin-left: 5px;
  position: relative;
  left: 100%;
  top: -2px;
  font-weight: 600;
  text-transform: uppercase;
  font-size: 0.75rem;
}

.partBar.error {
  animation-name: errorpulse;
  animation-duration: 2s;
  animation-iteration-count: infinite;
}
.partBar.warning {
  animation-name: warningpulse;
  animation-duration: 2s;
  animation-iteration-count: infinite;
}
.partBar.ok {
  animation-name: okpulse;
  animation-duration: 2s;
  animation-iteration-count: infinite;
}

.stagePartPar {
  height: 13px;
  margin-top: -5px;
  font-size: 0.625rem;
  border: none;
}

.stageTitle {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/projectplan/Stage.vue